import React from 'react';
export function Terms() {
  return <div className="bg-white min-h-screen py-20" data-id="element-326">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-327">
        <h1 className="text-4xl font-black text-slate-900 mb-8 uppercase tracking-tighter" data-id="element-328">
          Terms of Service
        </h1>
        <div className="prose prose-slate max-w-none space-y-6 text-slate-600 leading-relaxed" data-id="element-329">
          <p className="text-lg font-medium text-slate-900" data-id="element-330">
            Last Updated: May 19, 2026
          </p>
          <p data-id="element-331">
            By accessing or using the Daily Care Pharmacy website, you agree to
            be bound by these Terms of Service. Please read them carefully
            before using our services.
          </p>
          <h2 className="text-2xl font-bold text-slate-900 pt-4" data-id="element-332">
            Use of Services
          </h2>
          <p data-id="element-333">
            Our services are intended for personal, non-commercial use. You
            agree to provide accurate information when requesting prescription
            refills or clinical services.
          </p>
          <h2 className="text-2xl font-bold text-slate-900 pt-4" data-id="element-334">
            Medical Disclaimer
          </h2>
          <p data-id="element-335">
            The information provided on this website is for informational
            purposes only and is not a substitute for professional medical
            advice, diagnosis, or treatment. Always seek the advice of your
            physician or other qualified health provider.
          </p>
          <h2 className="text-2xl font-bold text-slate-900 pt-4" data-id="element-336">
            Limitation of Liability
          </h2>
          <p data-id="element-337">
            Daily Care Pharmacy shall not be liable for any direct, indirect,
            incidental, or consequential damages arising out of your use of our
            website or services.
          </p>
        </div>
      </div>
    </div>;
}